import { Injectable } from '@angular/core';
import { Namespace, Workflow } from 'enums-lib';
import { IWorkflowConfig } from 'interfaces-lib';
import { IdentityStorage } from 'storage-service-lib';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TemplateLinkService {
  constructor(private identityStorage: IdentityStorage) {}

  /**
   * Bullhorn only for now. The Action menu the link is pasted into is a Bullhorn feature
   */
  isDirectLinkEnabled(): boolean {
    return this.identityStorage.get().namespace === Namespace.bullhorn;
  }

  buildDirectLink(workflowConfig: Readonly<IWorkflowConfig>): string {
    const { namespace } = this.identityStorage.get();

    switch (namespace) {
      case Namespace.bullhorn:
        return this.buildBullhornDirectLink(workflowConfig);
      case Namespace.salesforce:
        return this.buildSalesforceDirectLink();
      case Namespace.invenias:
        return this.buildInveniasDirectLink();
      default:
        throw new Error(`Cannot build a template direct link for namespace '${namespace}'.`);
    }
  }

  private buildBullhornDirectLink(workflowConfig: Readonly<IWorkflowConfig>): string {
    return `${this.getAppHost(workflowConfig)}/${Namespace.bullhorn}?templateId=${encodeURIComponent(workflowConfig.id)}`;
  }

  private buildSalesforceDirectLink(): string {
    throw new Error('Template direct links are not enabled for Salesforce.');
  }

  private buildInveniasDirectLink(): string {
    throw new Error('Template direct links are not enabled for Invenias.');
  }

  private getAppHost(workflowConfig: Readonly<IWorkflowConfig>): string {
    switch (workflowConfig.workflow) {
      case Workflow.DocumentMerge:
        return environment.docMergeUrl;
      case Workflow.SimpleDocx:
        return environment.kpWebApp;
      default:
        throw new Error(`Cannot build a template direct link for workflow '${workflowConfig.workflow}'.`);
    }
  }
}
